import { ILocation } from '../api/locations';

export const getGeoSuggestLocation = (location: ILocation | 'moscow_mo' | 'spb_lo'): number =>
  (location === 'moscow_mo' && -1) || (location === 'spb_lo' && -2) || (location as ILocation).id;
